export interface PricingPackage {
    name: string;
    subtitle: string;
    price: string;
    priceNote?: string;
    features: string[];
    buttonText: string;
    popular?: boolean;
    emoji?: string;
}

export interface MenuItem {
    title: string;
    items: (string | { name: string; extra?: string; bestseller?: boolean; description?: string })[];
}

export interface FAQItem {
    question: string;
    answer: string;
}

export interface Story {
    name: string;
    location: string;
    date: string;
    content: string;
    tags: string[];
}

export interface EventPageData {
    id: string;
    title: string;
    subtitle: string;
    heroImage: string;
    description: string;
    heroButtons?: { text: string; link: string; variant: 'primary' | 'secondary' | 'accent' }[];
    accentColor?: string;
    sectionTitle?: string;
    storyTitle?: string;
    storySubtitle?: string;
    storyContent?: string;
    storyTitle2?: string;
    storySubtitle2?: string;
    storyContent2?: string;
    whyTitle?: string;
    whyFeatures?: { icon: string; title: string; description: string }[];
    whyTitle2?: string;
    whyFeatures2?: { icon: string; title: string; description: string }[];
    packagesTitle?: string;
    packagesSubtitle?: string;
    packages?: PricingPackage[];
    midnightSnack?: { title: string; description: string; subtext: string; price: string; buttonText: string };
    menuTitle?: string;
    menuSections?: MenuItem[];
    stories?: Story[];
    tastingInfo?: { title: string; subtitle: string; features: string[]; buttonText: string };
    faq?: FAQItem[];
    menuSpecialNote?: { title: string; text: string };
    heroTitle?: string;
    heroSubtitle?: string;
}

export const eventData: Record<string, EventPageData> = {
    weddings: {
        id: 'weddings',
        title: 'Jouw feest,',
        subtitle: 'onze passie',
        heroImage: '/images/gallery/hamburgers/Cheeseburger.jpg',
        heroSubtitle: '- Jouw feest, onze passie -',
        description: `Frietplus levert heerlijke, krokante frieten maar ook zoveel meer.
Onze verrassende huisgemaakte gerechten, zijn gemaakt met dagverse ingrediënten en hoevevlees van een lokale hoeveslager.
Kies verder uit sappige en rijkelijk gevulde hamburgers, overheerlijke snacks en selectief uitgekozen sausen.
Mag het wat meer zijn? De overheerlijke formules kunnen aangevuld worden met een kraakverse salade, overheerlijke aperitiefhapjes en huisbereide desserts. Onze foodtruck rijdt met plezier uit richting jouw event!`,
        heroButtons: [
            { text: 'Start Jullie Reis', link: '#packages', variant: 'primary' },
            { text: 'Bekijk Bruiloft Gallerij', link: '/gallery', variant: 'secondary' },
            { text: 'Vraag Proeverij Aan', link: '#tasting', variant: 'accent' }
        ],
        accentColor: '#D4AF37',
        menuSpecialNote: {
            title: 'Every event is special',
            text: 'Van communiefeesten en doopfeesten tot intieme tuinfeesten – FrietPlus brengt de magie van de Belgische frituur naar jouw speciale dag. Een trouwfeest? Frietplus zorgt voor de catering zodat jij zorgeloos kan genieten. Of stel je even voor: een prachtige zonsondergang aan de horizon en Frietplus die lekkere frietjes serveert voor al jouw gasten op het avondfeest!\n\nWelk gelegenheid dan ook, Frietplus zorgt voor een onvergelijkbare ervaring waar gasten nog lang over zullen praten.',
        },
        menuTitle: '',
        menuSections: [
            {
                title: 'Loaded Hamburgers',
                items: [
                    { name: 'Touch of vegan', description: 'Vegan Burger, Vegan bun, gouda slices, salsa, krulsla, tomaat en rode ajuin' },
                    { name: 'Chicken master', description: 'Chicken burger panné, Spelt pistolet, burgersaus, pepper jack slices, krulsla, tomaat en rode ajuin' },
                    { name: 'Dip in the ocean', description: 'Fishburger panné, Hamburger bun, tartaar speciaal, cheddar slices, krulsla, tomaat en rode ajuin' },
                    { name: 'Classic Cheeseburger', description: 'Hamburger hoevevlees, Tiger bun, burger saus, cheddar slices, krulsla, tomaat en rode ajuin' },
                    { name: 'American Classic', description: 'Hamburger hoevevlees, Hamburger bun, burgersaus, cheddar slices, crispy bacon, krulsla, tomaat en rode ajuin' },
                    { name: 'Italian Class', description: 'Hamburger hoevevlees, Hamburger bun bruin, burgersaus, pesto verde, parmesan schilfers, rucola, tomaat en rode ajuin' },
                    { name: 'Pulled Pork', description: 'Pulled Pork, brioche broodje, witte kool, geraspte wortel en dressing' },
                    { name: 'Bacon Delight', description: 'Hamburger hoevevlees, Whole meal burger bun, burgersaus, crispy bacon, krulsla, tomaat en rode ajuin' },
                    { name: 'Sweet Hawai', description: 'Hamburger hoevevlees, Hamburger bun, burgersaus, ananas, sla, tomaat en rode ajuin' }
                ]
            },
            {
                title: 'Slim Hamburger',
                items: [
                    { name: 'Hamburger Rageland', description: 'Ierse Steakburger van zuiver rundvlees, Hamburger bun, burgersaus, gebakken ajuin en (cheddar)' },
                    { name: 'Slim hamburger for kids', description: 'Mini hamburger hoevevlees, mini burgerbun, gebakken ajuin en (cheddar)' }
                ]
            },
            {
                title: 'Sauzen',
                items: ['Ketchup', 'Curry Ketchup', 'Mayonaise', 'Tartaar', 'Cocktail', 'Andalouse', 'Samourai', 'Toulouse']
            },
            {
                title: 'Salade',
                items: [
                    { name: '(seizoensgebonden)' },
                    { name: 'Zoetzure witte kool' },
                    { name: 'Sla' },
                    { name: 'Tomaat' },
                    { name: 'Mais' },
                    { name: 'Komkommer' },
                    { name: 'Geraspte worteltjes' },
                    { name: 'Zilveruitjes, augurken' },
                    { name: 'Rode Biet, ananas' },
                    { name: 'Boontje' },
                    { name: '…' }
                ]
            }
        ]
    },
    kids: {
        id: 'kids',
        title: 'Het Coolste Kinderfeestje',
        subtitle: 'Ever! 🎉',
        heroImage: '/images/kids.png',
        heroTitle: 'Kinderfeestje',
        heroSubtitle: '- Een Feestje om Nooit te Vergeten -',
        description: 'Maak je kinds verjaardag onvergetelijk met de FrietPlus Foodtruck! Verse frietjes, blije gezichtjes én zero stress voor de ouders. Stel je voor: de jarige staat gespannen te wachten. Dan rijdt de FrietPlus foodtruck de oprit op. Alle vriendjes rennen naar buiten. Ze mogen zelf hun sauzen kiezen, zien hoe de friet wordt gemaakt. Het feestje waar kids nog járen over praten!',
        heroButtons: [
            { text: 'Bekijk Pakketten', link: '#packages', variant: 'primary' },
            { text: 'Kids Menu', link: '#menu', variant: 'secondary' },
            { text: 'Boek Direct', link: '/contact', variant: 'accent' }
        ],
        accentColor: '#f472b6',
        storyTitle: 'Een Feestje met',
        storySubtitle: 'Extra Springplezier',
        storyContent: 'Frietplus zorgt niet enkel voor lekker eten maar ook voor extra springplezier met ons kleurrijk springkasteel. Het springkasteel wordt de dag voor of de ochtend van het feestje door ons geplaatst en de dag nadien opgehaald. Zo kan jouw kind extra lang genieten van springplezier.',
        menuSections: [
            {
                title: 'Slim Hamburger for kids',
                items: [
                    { name: 'Slim hamburger for kids', description: 'Mini hamburger hoevevlees, mini burgerbun, gebakken ajuin en (cheddar)' }
                ]
            },
            {
                title: 'Sauzen',
                items: ['Ketchup', 'Curry Ketchup', 'Mayonaise', 'Tartaar', 'Cocktail', 'Andalouse', 'Samourai', 'Toulouse']
            },
            {
                title: 'Salade',
                items: [
                    { name: '(seizoensgebonden)' },
                    { name: 'Zoetzure witte kool' },
                    { name: 'Sla' },
                    { name: 'Tomaat' },
                    { name: 'Mais' },
                    { name: 'Komkommer' },
                    { name: 'Geraspte worteltjes' },
                    { name: 'Zilveruitjes, augurken' },
                    { name: 'Rode Biet, ananas' },
                    { name: 'Boontje' },
                    { name: '…' }
                ]
            }
        ],
        stories: [
            {
                name: 'Sophie M.',
                location: 'Mama van Liam (8) - Mechelen',
                date: 'April 2024 - Super Party',
                content: '"Liam praat nog steeds over zijn FrietPlus feestje! De truck was een mega hit, de kinderen vonden het geweldig om te zien hoe de friet gemaakt werd. En ik? Ik heb voor het eerst van een kinderfeestje genoten zonder stress. Aanrader!"',
                tags: ['Super Party', '20 kids', 'Zero stress']
            },
            {
                name: 'Bart & Ellen',
                location: 'Ouders van Emma (6) - Gent',
                date: 'Juni 2024 - Mini Party',
                content: '"We hadden een kleine tuin en waren bang dat het niet zou passen. Maar de crew loste alles perfect op! Emma voelde zich een echte prinses met haar kroon. De goodie bags waren top. Perfect voor een eerste echt vriendinnenfeestje!"',
                tags: ['Mini Party', 'Kleine tuin', 'Prinsessenfeest']
            },
            {
                name: 'Linda K.',
                location: 'Mama van Tuur (10) - Antwerpen',
                date: 'September 2024 - Mega Party',
                content: '"30 kinderen voor Tuur zijn 10de verjaardag - ik was doodsbang. Maar FrietPlus regelde alles: de DJ, de games, de foto\'s. De kinderen waren 3 uur bezig en iedereen ging voldaan naar huis. Worth every penny!"',
                tags: ['Mega Party', '30 kids', 'DJ & Games']
            }
        ],
        tastingInfo: {
            title: 'Party Planning Service',
            subtitle: 'Wij helpen je het perfecte feestje plannen!',
            features: ['Gratis telefonisch advies', 'Hulp bij pakketkeuze', 'Allergie & dieet afstemming', 'Locatie check (indien nodig)', 'Persoonlijke wensen bespreken', 'Flexibele datum opties'],
            buttonText: 'Plan Adviesgesprek'
        },
        faq: [
            { question: 'Hebben de medewerkers een VOG?', answer: 'Ja, al onze medewerkers die op kinderfeestjes werken beschikken over een actueel VOG (Verklaring Omtrent het Gedrag). Veiligheid van kinderen staat bij ons voorop.' },
            { question: 'Houden jullie rekening met allergieën?', answer: 'Absoluut. Geef alle allergieën vooraf door, dan zorgen wij voor duidelijk gelabelde items en waar nodig aparte bereiding. Glutenvrij en vegetarisch is altijd mogelijk.' },
            { question: 'Wat als het regent op de dag van het feest?', answer: 'Geen probleem! Wij hebben een uitklapbaar afdak. Kids kunnen ook binnen eten terwijl ze buiten bij de truck hun eten halen. Echt slecht weer? We zoeken samen een oplossing.' },
            { question: 'Kunnen de ouders van de vriendjes ook mee-eten?', answer: 'Natuurlijk! Ouders zijn welkom. Bij de Super en Mega Party is er zelfs een "ouder-lounge" met koffie. Extra volwassen porties kunnen bijgeboekt worden voor €8 pp.' },
            { question: 'Hoeveel ruimte heeft de truck nodig?', answer: 'Minimaal 5x3 meter voor de truck. Een standaard oprit is meestal voldoende. Twijfel je? Stuur een foto en we adviseren je graag!' },
            { question: 'Kunnen jullie ook naar een speeltuin of park komen?', answer: 'Ja, mits er toegang is voor de truck en we toestemming hebben (gemeente/beheerder). We helpen je graag met de aanvraag!' },
            { question: 'Kan de jarige een speciale wens doen?', answer: 'Zeker! Lievelingskleur decoratie, specifiek liedje, bepaalde snack - bespreek het met ons en we maken het mogelijk. Het is tenslotte HUN dag!' }
        ]
    },
    'private-parties': {
        id: 'private-parties',
        title: 'Vier het Leven met',
        subtitle: 'FrietPlus',
        heroImage: '/images/jubilea.png',
        description: 'Communiefeest, babyborrel of Nieuwjaarsreceptie gepland en mag het eens wat luxueuzer zijn? Neem afscheid van het traditionele diner aan tafel en ga mee op pad met onze foodtruck voor een unieke walking dinner ervaring. Proef van een uitgebreid smakenpalet terwijl je geniet van een avondje vol heerlijke gesprekken met familie, vrienden of collega\'s. Ontdek onze formules hieronder.',
        heroButtons: [
            { text: 'Bekijk Pakketten', link: '#packages', variant: 'primary' },
            { text: 'Bekijk Menu', link: '#menu', variant: 'secondary' },
            { text: 'Vraag Offerte', link: '/contact', variant: 'accent' }
        ],
        accentColor: '#ec4899',
        stories: [
            {
                name: 'Paul & Marie',
                location: 'Familie Reünie - Brasschaat',
                date: 'Augustus 2024 - 85 gasten',
                content: '"Na 3 jaar corona was dit onze eerste grote familiereünie. FrietPlus zorgde ervoor dat we echt konden genieten. Opa was in tranen van de "echte friet van vroeger". De kleinkinderen vonden de truck geweldig. Perfect!"',
                tags: ['Familie reünie', '85 gasten', 'Drie generaties']
            },
            {
                name: 'An V.',
                location: '50ste Verjaardag - Gent',
                date: 'Juni 2024 - 60 gasten',
                content: '"Ik wilde geen gedoe met catering en afwas op mijn 50ste. FrietPlus was de perfecte oplossing. De gasten waren verrast en enthousiast. En ik? Ik heb gewoon meegegeten en gefeest!"',
                tags: ['Verjaardag', 'Tuin party', 'Zero stress']
            },
            {
                name: 'Koen D.',
                location: 'Pensioenfeest - Antwerpen',
                date: 'September 2024 - 45 gasten',
                content: '"Voor het pensioen van mijn vader wilden we iets bijzonders. De foodtruck was een schot in de roos. Collega\'s, familie, buren - iedereen genoot. De gepersonaliseerde servetten met "Proficiat Roger!" waren een leuke touch."',
                tags: ['Pensioen', 'Gepersonaliseerd', '45 gasten']
            }
        ],
        tastingInfo: {
            title: 'Gratis Proefpakket',
            subtitle: 'Bij boekingen van 75+ personen',
            features: ['Proeverij voor 4 personen', 'Alle sauzen uitproberen', 'Menu samenstellen', 'Persoonlijk advies', 'Geen verplichtingen'],
            buttonText: 'Vraag Proefpakket Aan'
        },
        faq: [
            { question: 'Wat is de actieradius?', answer: 'Wij zijn actief in heel België. Voor locaties buiten een straal van 50km rond Antwerpen rekenen we een kleine transportkost.' },
            { question: 'Hoeveel ruimte heeft de truck nodig?', answer: 'Minimaal 6x4 meter voor de truck zelf, plus wat ruimte voor gasten om te staan. Een standaard oprit of tuinpad is meestal voldoende.' },
            { question: 'Wat als het regent?', answer: 'Wij hebben een uitklapbaar afdak bij de truck. Bij slecht weer kunnen gasten ook binnen eten terwijl wij buiten serveren. Annuleren wegens weer hoeft bijna nooit!' },
            { question: 'Kunnen jullie rekening houden met allergieën?', answer: 'Absoluut. Geef vooraf de allergieën door en wij zorgen voor duidelijke labeling en waar nodig aparte bereiding. Glutenvrij en vegan is standaard mogelijk.' },
            { question: 'Hoe lang duurt de setup?', answer: 'Wij arriveren 30-45 minuten voor de afgesproken starttijd. Setup is snel en professioneel, zonder overlast voor jou of je gasten.' },
            { question: 'Moet ik zelf iets regelen qua stroom?', answer: 'Nee, onze trucks zijn volledig zelfvoorzienend met een stille generator. Je hoeft niets te regelen - wij zijn 100% standalone.' },
            { question: 'Kunnen jullie ook een taart meebrengen?', answer: 'Wij focussen op friet en snacks, maar we werken samen met lokale bakkers. Vraag naar de mogelijkheden!' },
            { question: 'Wat gebeurt er met restjes?', answer: 'Wij calculeren nauwkeurig op basis van je gastenaantal. Eventuele restjes nemen wij mee of doneren we aan een lokale voedselbank.' }
        ]
    },
    'special-occasions': {
        id: 'special-occasions',
        title: 'Speciale Gelegenheden',
        subtitle: '',
        heroImage: '/images/special.png',
        description: 'Van communiefeesten en doopfeesten tot intieme tuinfeesten \u2013 FrietPlus brengt de magie van de Belgische frituur naar jouw speciale dag. Wij zorgen voor een onvergetelijke culinaire ervaring waar gasten nog lang over zullen napraten.',
        heroButtons: [
            { text: 'Start Jullie Reis', link: '#packages', variant: 'primary' },
            { text: 'Bekijk Gallerij', link: '/gallery', variant: 'secondary' },
            { text: 'Vraag Offerte', link: '/contact', variant: 'accent' }
        ],
        accentColor: '#D4AF37',
        storyTitle: 'Elk Liefdsverhaal Verdient een',
        storySubtitle: 'Happy Ending',
        storyContent: 'Stel je voor: Na de ceremonie, tijdens het golden hour, verschijnt onze elegante foodtruck. De geur van verse frieten vult de lucht. Gasten verzamelen zich, lachen, delen verhalen. Jullie grootouders glimlachen nostalgisch. De kinderen zijn dolgelukkig. Instagram explodeert met #FrietPlusLove posts.',
        whyTitle: 'Waarom FrietPlus voor Jouw Feest?',
        whyFeatures: [
            { icon: 'fas fa-home', title: 'Bij Jou Thuis', description: 'Wij komen naar je oprit, tuin, garage of gekozen locatie. Jouw vertrouwde omgeving, ons premium eten. Geen gedoe met vervoer of locatiehuur.' },
            { icon: 'fas fa-utensils', title: 'Iedereen Blij', description: 'Van kleine kinderen tot opa en oma - friet maakt iedereen gelukkig. Met vegetarische en allergie-opties is er voor elk wat wils.' },
            { icon: 'fas fa-hand-sparkles', title: 'Volledige Ontzorging', description: 'Wij regelen alles: setup, bediening, én opruimen. Jij hoeft alleen maar te genieten van je gasten en het feest.' },
            { icon: 'fas fa-clock', title: 'Flexibele Timing', description: 'Of het nou een lunch, diner of late-night snack is - wij passen ons aan jouw planning aan. Jouw feest, jouw tijdschema.' },
            { icon: 'fas fa-euro-sign', title: 'Transparante Prijzen', description: 'All-in tarieven zonder verrassingen. Je weet vooraf exact wat het kost. Geen verborgen kosten voor transport of opruimen.' },
            { icon: 'fas fa-heart', title: 'Persoonlijke Touch', description: 'Verjaardagslied, gepersonaliseerde servetten, speciale dieetwensen - wij maken het persoonlijk en onvergetelijk.' }
        ],
        packagesTitle: 'Bruiloft Pakketten',
        packagesSubtitle: 'Elk pakket is aan te passen aan jullie wensen',
        packages: [
            {
                name: 'Romantisch',
                subtitle: 'Intieme Viering (50-100 gasten)',
                price: '\u20AC15',
                priceNote: 'per persoon',
                emoji: '\uD83D\uDC91',
                features: ['2 uur premium service', 'Elegant opgezette friet bar', '8 artisanale sauzen', 'Champagne voor het bruidspaar', 'Gepersonaliseerde menu kaarten', 'Witte foodtruck met bloemen decoratie'],
                buttonText: 'Boek Romantisch'
            },
            {
                name: 'Elegant',
                subtitle: 'Klassieke Bruiloft (100-200 gasten)',
                price: '\u20AC13',
                priceNote: 'per persoon',
                emoji: '\uD83D\uDC90',
                popular: true,
                features: ['3 uur full service', 'Friet + 3 premium snacks', '12 sauzen inclusief truffle mayo', 'Dedicated service team (2 personen)', 'Gold-accent presentatie', 'Late night snack optie'],
                buttonText: 'Populairste Keuze'
            },
            {
                name: 'Royaal',
                subtitle: 'Grote Viering (200+ gasten)',
                price: '\u20AC11',
                priceNote: 'per persoon',
                emoji: '\uD83D\uDC51',
                features: ['4 uur onbeperkte service', 'Volledig snack menu', 'Unlimited gourmet sauzen', '3-person service team', 'Dubbele station setup', 'Champagne toast service'],
                buttonText: 'Plan Royaal'
            }
        ],
        midnightSnack: {
            title: '\uD83C\uDF19 Midnight Snack Add-on',
            description: 'De perfecte dance floor fuel wanneer het feest echt losbarst!',
            subtext: 'Mini friet portions, select sauzen, 1 uur service (23:00-00:00)',
            price: '\u20AC5',
            buttonText: 'Add Magic'
        },
        menuTitle: 'Menu Speciale Gelegenheden',
        menuSections: [
            {
                title: 'Frieten Selectie',
                items: [
                    { name: 'Classic Belgian', bestseller: true },
                    { name: 'Sweet Potato', extra: '+\u20AC2' },
                    { name: 'Truffle Parmesan', extra: '+\u20AC3' },
                    { name: 'Loaded Wedding Fries', extra: '+\u20AC4' }
                ]
            },
            {
                title: 'Sauzen',
                items: ['Ketchup', 'Curry Ketchup', 'Mayonaise', 'Tartaar', 'Cocktail', 'Andalouse', 'Samourai', 'Toulouse']
            },
            {
                title: 'Premium Sides',
                items: ['Mini Kroketjes', 'Bitterballen Selectie', 'Vegetarische Loempia\'s', 'Chicken Tenders', 'Vegan Nuggets', 'Garnaal Kroketjes']
            }
        ],
        stories: [
            {
                name: 'Sarah & Tom',
                location: 'Kasteel Wijnendale',
                date: 'Juni 2024 - 150 gasten',
                content: '"We wilden iets anders dan de typische bruiloft catering. FrietPlus was the perfect surprise! Onze gasten praten er nog steeds over. De presentatie was elegant, de service onberispelijk, en de frieten... gewoon perfect!"',
                tags: ['Sunset service', 'Custom sauce bar', 'Midnight snack']
            },
            {
                name: 'Emma & Lucas',
                location: 'Landgoed De Hooge Vuursche',
                date: 'September 2024 - 200 gasten',
                content: '"De midnight snack was de absolute hit van onze bruiloft! Om middernacht, midden op de dansvloer, verse frieten. Onze gasten gingen helemaal los. De witte truck met bloemen was prachtig als foto achtergrond. #FrietPlusLove was trending onder onze vrienden!"',
                tags: ['Midnight snack', '200 gasten', 'Instagram hit']
            },
            {
                name: 'Julie & Pieter',
                location: 'Eigen tuin - Brasschaat',
                date: 'Augustus 2024 - 80 gasten',
                content: '"We hadden een intieme tuinbruiloft gepland en FrietPlus paste perfect bij onze relaxte vibe. Oma was in tranen - "dit is echte friet zoals vroeger". De kids konden niet stoppen met eten. Het was precies wat we wilden: kwaliteit zonder pretentie."',
                tags: ['Tuinbruiloft', 'Intiem', 'Familiesfeer']
            }
        ],
        tastingInfo: {
            title: 'Try Before Your Big Day',
            subtitle: 'Complimentary tasting session voor bruiloften van 100+ gasten',
            features: ['Priv\u00E9 tasting voor 4 personen', 'Volledig menu sampling', 'Sauce pairing advice', 'Service style demonstration', 'Planning consultation'],
            buttonText: 'Book Free Tasting'
        },
        faq: [
            { question: 'Hoeveel ruimte hebben jullie nodig?', answer: 'Minimum 6x4 meter voor de truck, plus service area. We kunnen aanpassen aan jullie venue.' },
            { question: 'Wat als het regent?', answer: 'We hebben elegante tenten en kunnen indoor setup doen. Het weer vormt nooit een probleem!' },
            { question: 'Kunnen jullie ons kleurthema matchen?', answer: 'Absoluut! Van servetten tot truck decoratie, we passen alles aan jullie thema aan.' },
            { question: 'Zijn jullie FAVV gecertificeerd?', answer: 'Zeker. Wij voldoen aan alle Belgische voedselveiligheidsnormen en zijn volledig FAVV gecertificeerd.' },
            { question: 'Hoe werkt de gratis proeverij?', answer: 'Bij bruiloften van 100+ gasten bieden we een gratis proeverij aan voor 4 personen. Jullie proeven het volledige menu, bespreken de opties, en ontmoeten jullie wedding coordinator. Plan minimaal 6 weken voor de bruiloft.' },
            { question: 'Kunnen jullie meerdere dietary opties aan?', answer: 'Absoluut! Van vegan tot glutenvrij, van halal tot lactosevrij - wij bereiden alles apart en labelen duidelijk. Geef dietary wensen door bij boeking en wij zorgen dat elke gast kan genieten.' },
            { question: 'Hoe laat kunnen jullie blijven?', answer: 'Onze standaard service loopt tot middernacht. Voor de midnight snack add-on serveren we tot 01:00. Later is bespreekbaar - vraag naar de mogelijkheden voor jullie feest!' },
            { question: 'Wat is het aanbetaling beleid?', answer: '30% aanbetaling bij boeking om de datum vast te leggen. Restbedrag 2 weken voor de bruiloft. Flexibele annulering tot 4 weken vooraf (50% terug), tot 2 weken (25% terug).' }
        ]
    },
    corporate: {
        id: 'corporate',
        title: 'Bedrijfsevents die',
        subtitle: 'Teams Verbinden',
        heroImage: '/images/gallery/overige/Sfeerbeelden/Erasmus.jpg',
        heroTitle: 'Bedrijfsevent',
        heroSubtitle: '- Jouw Succes is Ons Succes -',
        description: 'Boost teamspirit en vier successen met FrietPlus foodtruck catering voor bedrijfsevents. Van teamlunches tot company festivals - professioneel, efficiënt en onvergetelijk.\n\nWij begrijpen dat jouw reputatie op het spel staat bij elk event. Daarom gaan we verder dan alleen leveren - we denken mee, reageren snel, en zorgen dat jij er goed uitkomt bij je klant.',
        heroButtons: [
            { text: 'Vraag Offerte', link: '/contact', variant: 'primary' },
            { text: 'Referenties', link: '#stories', variant: 'secondary' },
            { text: 'Plan Pilot Event', link: '#packages', variant: 'accent' }
        ],
        accentColor: '#2563eb',
        storyTitle: 'Employee Experience',
        storySubtitle: 'Die Het Verschil Maakt',
        storyContent: 'In een competitieve arbeidsmarkt telt elk detail. Premium catering die iedereen includeert - van vegan tot halal, van glutenvrij tot lactose-intolerant - laat zien dat u om uw mensen geeft. FrietPlus levert niet alleen eten, maar een statement over uw bedrijfscultuur.',
        whyTitle: 'Waarom HR Managers Kiezen voor FrietPlus',
        whyFeatures: [
            { icon: 'fas fa-bolt', title: 'Hoge Capaciteit', description: 'Wij bedienen honderden medewerkers in recordtempo zonder kwaliteitsverlies. Perfect voor lunchpauzes en grote events.' },
            { icon: 'fas fa-heart', title: 'Dietary Excellence', description: '40% van werknemers heeft speciale dieetwensen. Wij accommoderen 100% - vegan, halal, glutenvrij, lactosevrij - allemaal met duidelijke labeling.' },
            { icon: 'fas fa-users-gear', title: 'Employer Branding', description: 'Versterk uw werkgeversmerk met premium catering die inclusiviteit uitstraalt. Perfect voor recruitmentdagen, team events en bedrijfsjubilea.' },
            { icon: 'fas fa-shield-alt', title: 'Compliance & Veiligheid', description: 'FAVV gecertificeerd, HACCP protocollen.' },
            { icon: 'fas fa-leaf', title: 'Sustainability Focus', description: 'Lokale Belgische leveranciers, eco-verpakkingen of maak gebruik van ons herbruikbaar servies.' }
        ],
        packagesTitle: 'Corporate Pakketten',
        packagesSubtitle: 'Flexibel van pilot tot jaarcontract',
        packages: [
            {
                name: 'Team Lunch',
                subtitle: 'Snelle service (50-100 pers.)',
                price: '€13',
                priceNote: 'per persoon',
                emoji: '🍽️',
                features: ['60-90 min service window', 'Gourmet friet & 2 snacks', '8 sauzen inclusief dietary', 'Dietary labeling systeem', 'Professionele crew (2 pers.)', 'Complete setup & cleanup'],
                buttonText: 'Plan Team Lunch'
            },
            {
                name: 'Company Event',
                subtitle: 'De populaire keuze (100-300 pers.)',
                price: '€11',
                priceNote: 'per persoon',
                emoji: '🎯',
                popular: true,
                features: ['2-3 uur full service', 'Friet + 3 premium snacks', '12+ sauzen selectie', 'Dedicated event manager', 'Branded servetten mogelijk', 'Dietary management systeem', 'Volume korting bij 150+'],
                buttonText: 'Meest Gekozen!'
            },
            {
                name: 'Jaarcontract',
                subtitle: 'Partnership voor 4+ events',
                price: '€9',
                priceNote: 'per persoon',
                emoji: '🤝',
                features: ['10-15% jaarkorting', 'Vaste contactpersoon', 'Priority booking garantie', 'Pilot event mogelijkheid', 'Kwartaal innovatie meetings', 'Custom menu ontwikkeling', 'Sustainability rapportage'],
                buttonText: 'Word Partner'
            }
        ],
        menuTitle: 'Corporate Menu Opties',
        menuSections: [
            {
                title: 'Basis Selectie',
                items: [
                    { name: 'Classic Belgian Fries', bestseller: true },
                    'Sweet Potato Fries',
                    'Veggie Snack Mix',
                    'Chicken Tenders'
                ]
            },
            {
                title: 'Dietary Opties',
                items: [
                    { name: 'Vegan Nuggets', extra: 'plantaardig' },
                    { name: 'Glutenvrije Friet', extra: 'apart gebakken' },
                    { name: 'Halal Snacks', extra: 'gecertificeerd' }
                ]
            },
            {
                title: 'Premium Add-ons',
                items: [
                    { name: 'Gourmet Kroketjes', extra: '+€2' },
                    { name: 'Bitterballen Selectie', extra: '+€2' },
                    { name: 'Garnaal Kroketjes', extra: '+€3' }
                ]
            }
        ],
        stories: [
            {
                name: 'Emma V.',
                location: 'HR Director @ TechCorp Belgium',
                date: 'Mei 2024 - 400 medewerkers',
                content: '"De efficiency was indrukwekkend. We hadden 400 man te voeden in een pauze van een uur - FrietPlus klaarde de klus met een glimlach. De dietary inclusivity werd enorm gewaardeerd door ons diverse team. Employee NPS steeg met 15 punten na dit event!"',
                tags: ['High capacity', 'Dietary excellence', '400+ personen']
            },
            {
                name: 'Jan D.',
                location: 'Office Manager @ Scale-Up Hub',
                date: 'September 2024 - Jaarcontract',
                content: '"We organiseren maandelijks team events en FrietPlus is onze vaste partner geworden. De consistentie is geweldig - elke keer dezelfde hoge kwaliteit. Het jaarcontract bespaart ons 15% en de vaste contactpersoon kent onze voorkeuren."',
                tags: ['Jaarcontract', 'Maandelijkse events', 'Consistency']
            },
            {
                name: 'Lisa M.',
                location: 'Event Coordinator @ Pharma NV',
                date: 'December 2024 - Eindejaarsfeest',
                content: '"Voor ons eindejaarsfeest met 250 mensen zochten we iets anders dan de standaard catering. FrietPlus leverde een complete experience - van de branded servetten tot de midnight snack. De CSR-rapportage was een bonus voor onze sustainability doelen."',
                tags: ['250 personen', 'Branded service', 'CSR compliant']
            }
        ],
        tastingInfo: {
            title: 'Pilot Event Aanvragen',
            subtitle: 'Test onze service met een kleinschalig event',
            features: ['Klein team event (50 pers.)', 'Volledige service ervaring', 'Evaluatie meeting achteraf', 'Geen verplichtingen', 'Korting op eerste groot event'],
            buttonText: 'Plan Pilot Event'
        },
        faq: [
            { question: 'Kunnen we op rekening betalen?', answer: 'Ja, voor zakelijke klanten bieden we de mogelijkheid om op factuur te betalen met duidelijke BTW-specificaties. PO-nummers worden geaccepteerd.' },
            { question: 'Hoe werkt dietary management?', answer: '40% van werknemers heeft speciale wensen. Wij vragen vooraf een dietary matrix op, labelen alle items duidelijk, en bereiden allergie-gevoelige items apart. 100% accommodation rate.' },
            { question: 'Wat zijn de voordelen van een jaarcontract?', answer: 'Bij 4+ events per jaar krijgt u 10-15% korting, een vaste contactpersoon, priority booking, en toegang tot onze innovatie meetings waar we nieuwe concepten presenteren.' },
            { question: 'Kunnen jullie branding toevoegen?', answer: 'Absoluut. Van branded servetten tot logo op de truck - we passen ons aan uw corporate identity aan. Vraag naar de mogelijkheden.' },
            { question: 'Hoe snel kunnen jullie een offerte leveren?', answer: 'Wij hanteren een 2-uur response garantie tijdens kantooruren. Complete offertes inclusief alle specificaties binnen 24 uur.' },
            { question: 'Bieden jullie sustainability rapportage?', answer: 'Ja. We kunnen rapporteren over lokale sourcing percentage, eco-verpakkingen gebruik, en CO2-footprint. Perfect voor uw CSR-doelstellingen.' },
            { question: 'Wat is jullie capaciteit voor lunch events?', answer: 'Voor een 1-uur lunchpauze kunnen we tot 300 medewerkers bedienen met één truck, of meer met multi-unit setup.' },
            { question: 'Kunnen jullie meerdere locaties bedienen?', answer: 'Ja, we hebben meerdere units en kunnen gelijktijdig op verschillende locaties aanwezig zijn. Ideaal voor bedrijven met meerdere vestigingen.' }
        ]
    },
    festivals: {
        id: 'festivals',
        title: 'Festivals & Publieke Events',
        subtitle: '100% Compliance Gegarandeerd',
        heroImage: '/images/festival.png',
        description: 'Van gemeentefestivals tot sportevenementen - FrietPlus levert schaalbare, compliant oplossingen voor publieke events tot 5000 personen. Volledige documentatie voor aanbestedingen beschikbaar.',
        heroButtons: [
            { text: 'Vraag Offerte', link: '/contact', variant: 'primary' },
            { text: 'Compliance Docs', link: '#compliance', variant: 'secondary' },
            { text: 'Raamcontract Info', link: '#packages', variant: 'accent' }
        ],
        accentColor: '#059669',
        storyTitle: 'Uw Partner voor',
        storySubtitle: 'Publiek Succes',
        storyContent: 'Gemeente-events staan onder een vergrootglas. Burgers verwachten kwaliteit, politiek wil succes, en alles moet 100% compliant zijn. FrietPlus begrijpt deze dynamiek. Wij leveren niet alleen premium friet, maar ook volledige gemoedsrust met documentatie die elke audit doorstaat.',
        whyTitle: 'Gebouwd voor Publieke Events',
        whyFeatures: [
            { icon: 'fas fa-shield-alt', title: '100% Compliance', description: 'FAVV gecertificeerd, €2M aansprakelijkheidsverzekering, sociale & fiscale attesten actueel. Alle documentatie direct beschikbaar voor tenders.' },
            { icon: 'fas fa-truck-moving', title: 'Schaalbaar tot 5000', description: 'Van dorpsfeest (200 pers.) tot groot stadsfestival (5000 pers.) - multi-unit setup met centrale coördinatie.' },
            { icon: 'fas fa-users-viewfinder', title: 'Expert Crew', description: 'Ervaren personeel dat de druk van publieke events moeiteloos aan kan. 300 porties per uur per unit, altijd met een glimlach.' },
            { icon: 'fas fa-clock', title: '100% Op Tijd Garantie', description: 'In 5 jaar nooit te laat. Wij plannen buffers, hebben backup equipment, en communiceren proactief bij elke wijziging.' },
            { icon: 'fas fa-triangle-exclamation', title: 'Crisis Management', description: 'Uitgewerkte noodplannen, backup voorraad, reserve equipment, 24/7 bereikbaarheid tijdens events. Uw zero-incident partner.' },
            { icon: 'fas fa-map-location-dot', title: 'Lokale Sourcing', description: 'Belgische aardappelen, lokale leveranciers waar mogelijk. Perfect voor uw lokale economie verhaal en duurzaamheidsbeleid.' }
        ],
        packagesTitle: 'Samenwerkingsmodellen',
        packagesSubtitle: 'Flexibel: van eenmalig tot raamcontract',
        packages: [
            {
                name: 'Gemeente Event',
                subtitle: 'Eenmalig publiek event',
                price: '€9',
                priceNote: 'per persoon (min. 200)',
                emoji: '🏛️',
                features: ['Volledige compliance docs', 'Setup & breakdown service', 'All-in prijs incl. afval', 'Evaluatierapport achteraf', 'Publieksvriendelijke presentatie', '24/7 contact tijdens event'],
                buttonText: 'Vraag Offerte'
            },
            {
                name: 'Raamcontract',
                subtitle: '1-3 jaar partnership',
                price: 'Op Maat',
                priceNote: 'volume gebaseerd',
                emoji: '📋',
                popular: true,
                features: ['Vaste prijsafspraken', 'Gegarandeerde beschikbaarheid', 'SLA met KPIs', 'Quarterly review meetings', 'Prioriteit bij grote events', 'Dedicated accountmanager', 'Pilot event optie'],
                buttonText: 'Bespreek Raamcontract'
            },
            {
                name: 'Revenue Share',
                subtitle: 'Commissiemodel festivals',
                price: 'Geen Vooraf',
                priceNote: 'commissie basis',
                emoji: '🎪',
                features: ['Geen investering vooraf', 'Gedeeld omzet risico', 'Wij regelen alles', 'Transparante afrekening', 'Ideal voor festivals', 'Meerdere standlocaties'],
                buttonText: 'Bespreek Model'
            }
        ],
        stories: [
            {
                name: 'Marc V.',
                location: 'Evenementencoördinator Stad Gent',
                date: 'Zomer 2024 - 3 stadsfestivals',
                content: '"FrietPlus was de enige aanbieder die direct alle compliance documentatie klaar had. De tender verliep soepel en de uitvoering was vlekkeloos. 3000 bezoekers bediend zonder één klacht. Volgend jaar weer!"',
                tags: ['Gemeente', '3000 bezoekers', 'Tender compliant']
            },
            {
                name: 'Sophie D.',
                location: 'Organisatie Sportdag Limburg',
                date: 'Oktober 2024 - 1500 deelnemers',
                content: '"De snelheid was indrukwekkend. Tijdens de lunchpauze van 45 minuten werden alle 1500 sporters bediend. De lokale sourcing was een bonus voor onze duurzaamheidsambities."',
                tags: ['Sportevent', '1500 personen', 'Snelle service']
            }
        ],
        tastingInfo: {
            title: 'Compliance Centrum',
            subtitle: 'Alle documentatie voor uw aanbesteding',
            features: ['FAVV certificering (actueel)', '€2M aansprakelijkheidsverzekering', 'Sociale & fiscale attesten', 'HACCP documentatie', 'Noodplan & procedures', 'Referentielijst gemeentes'],
            buttonText: 'Download Compliance Pakket'
        },
        faq: [
            { question: 'Wat is jullie maximale capaciteit?', answer: 'Met onze multi-unit setup kunnen we tot 5000 personen bedienen op een enkele dag. Voor grotere events schakelen we strategische partners in.' },
            { question: 'Werken jullie ook met revenue sharing?', answer: 'Ja. Voor festivals en publieke events bieden we commissiemodellen waarbij u geen investering vooraf doet. We delen het omzetrisico en regelen alles zelf.' },
            { question: 'Welke documenten hebben jullie voor tenders?', answer: 'Wij hebben een compleet tender pakket: FAVV certificering, €2M verzekeringspolis, actuele sociale en fiscale attesten, HACCP documentatie, en referentiebrieven van andere gemeentes.' },
            { question: 'Hoe werkt een raamcontract?', answer: 'Bij een raamcontract (1-3 jaar) spreken we vaste prijzen af, garanderen we beschikbaarheid, en houden we quarterly reviews. U krijgt een dedicated accountmanager en priority access.' },
            { question: 'Hebben jullie noodplannen?', answer: 'Absoluut. Wij hebben uitgewerkte crisis protocols voor equipment failure, weersomstandigheden, en personeelsuitval. Backup equipment is standaard beschikbaar.' },
            { question: 'Hoe gaan jullie om met lokale sourcing?', answer: 'Wij werken met Belgische aardappelleveranciers en lokale partners waar mogelijk. We kunnen dit rapporteren voor uw duurzaamheidsbeleid en lokale economie communicatie.' },
            { question: 'Wat is jullie service snelheid?', answer: '300 porties per uur per unit. Met 3 units kunnen we 900 porties per uur serveren - ideaal voor grote pauze momenten op festivals.' },
            { question: 'Bieden jullie evaluatierapporten?', answer: 'Ja. Na elk event leveren we een evaluatierapport met aantallen, feedback, en verbeterpunten. Dit is ook nuttig voor uw interne rapportage.' }
        ]
    },
    partners: {
        id: 'partners',
        title: 'Word FrietPlus',
        subtitle: 'Preferred Partner',
        heroImage: '/images/partner.png',
        description: 'Als event professional weet je: betrouwbare partners zijn goud waard. Word FrietPlus Preferred Partner en profiteer van priority booking, volume kortingen, en een dedicated contactpersoon die jouw events kent.',
        heroButtons: [
            { text: 'Word Partner', link: '/contact', variant: 'primary' },
            { text: 'Partner Voordelen', link: '#packages', variant: 'secondary' },
            { text: 'Download Brochure', link: '#brochure', variant: 'accent' }
        ],
        accentColor: '#7c3aed',
        storyTitle: 'Jouw Succes is',
        storySubtitle: 'Ons Succes',
        storyContent: 'Wij begrijpen dat jouw reputatie op het spel staat bij elk event. Daarom gaan we verder dan alleen leveren - we denken mee, reageren snel, en zorgen dat jij er goed uitkomt bij je klant. Met FrietPlus als partner krijg je niet alleen premium friet, maar een strategische ally.',
        whyTitle: 'Waarom Event Professionals Kiezen voor FrietPlus',
        whyFeatures: [
            { icon: 'fas fa-bolt', title: '2-Uur Response Garantie', description: 'Tijdens kantooruren reageren wij binnen 2 uur op elke vraag. Complete offertes binnen 24 uur. Jij kunt je klant snel antwoord geven.' },
            { icon: 'fas fa-star', title: 'Jouw Reputatie Beschermd', description: '100% on-time track record in 5 jaar. Crisis backup protocollen. Wij falen nooit - jouw reputatie is veilig bij ons.' },
            { icon: 'fas fa-percent', title: 'Partner Kortingen', description: '10-20% korting op alle events. Volume staffels die meegroeien met je business. Transparante prijzen zonder verrassingen.' },
            { icon: 'fas fa-user-tie', title: 'Dedicated Contact', description: 'Eén contactpersoon die jouw events en voorkeuren kent. Geen uitleg nodig, wij snappen wat je nodig hebt.' },
            { icon: 'fas fa-images', title: 'Co-Marketing Support', description: 'Hi-res foto\'s en video\'s voor je portfolio. Case studies met quotes. Instagram-ready content. Referral fee programma.' },
            { icon: 'fas fa-calendar-check', title: 'Priority Booking', description: 'Als partner krijg je voorrang bij populaire data. Flexibele annulering tot 48u vooraf. Last-minute service mogelijk.' }
        ],
        packagesTitle: 'Partnership Levels',
        packagesSubtitle: 'Groei met ons mee',
        packages: [
            {
                name: 'Silver Partner',
                subtitle: '3-5 events per jaar',
                price: '10%',
                priceNote: 'korting',
                emoji: '🥈',
                features: ['10% partner korting', '48-uur response garantie', 'Priority booking weekdagen', 'Hi-res event foto\'s', 'Case study mogelijkheid', 'Quarterly partner call'],
                buttonText: 'Start Silver'
            },
            {
                name: 'Gold Partner',
                subtitle: '6-12 events per jaar',
                price: '15%',
                priceNote: 'korting',
                emoji: '🥇',
                popular: true,
                features: ['15% partner korting', '2-uur response garantie', 'Priority booking alle dagen', 'Dedicated contactpersoon', 'Co-marketing budget', 'Referral fee (5%)', 'Exclusive preview nieuwe menu\'s'],
                buttonText: 'Meest Populair'
            },
            {
                name: 'Platinum Partner',
                subtitle: '12+ events per jaar',
                price: '20%',
                priceNote: 'korting',
                emoji: '💎',
                features: ['20% maximum korting', 'Instant response lijn', 'Gegarandeerde beschikbaarheid', 'Senior accountmanager', 'Joint marketing campaigns', 'Referral fee (10%)', 'White-label optie', 'Annual partner gala'],
                buttonText: 'Word Platinum'
            }
        ],
        stories: [
            {
                name: 'Lisa D.',
                location: 'EventPro Agency - Gold Partner',
                date: '2 jaar partnership - 20+ events',
                content: '"FrietPlus is mijn go-to voor foodtruck catering. De snelle response, de consistente kwaliteit, en het feit dat ze mijn klanten kennen - dat maakt het verschil. Mijn reputatie is veilig bij hen."',
                tags: ['Gold Partner', '20+ events', '2 jaar']
            },
            {
                name: 'Koen V.',
                location: 'Wedding Planner Antwerpen - Platinum',
                date: '3 jaar partnership - 35+ bruiloften',
                content: '"De white-label optie is perfect voor mijn high-end klanten. FrietPlus past zich aan mijn branding aan en levert altijd top. De referral fee is een leuke bonus!"',
                tags: ['Platinum', 'White-label', 'Wedding specialist']
            },
            {
                name: 'Sarah M.',
                location: 'Corporate Event Specialist - Silver',
                date: '1 jaar partnership - 8 events',
                content: '"Na één succesvol event was ik verkocht. De case study die ze maakten hielp me 3 nieuwe corporate klanten binnen te halen. Win-win partnership!"',
                tags: ['Silver Partner', 'Co-marketing', 'Corporate events']
            }
        ],
        tastingInfo: {
            title: 'Partner Onboarding',
            subtitle: 'Start jouw partnership vandaag',
            features: ['Kennismaking meeting', 'Portfolio review', 'Prijsafspraken op maat', 'Systemen integratie', 'First event support', 'Dedicated contact toewijzing'],
            buttonText: 'Plan Kennismaking'
        },
        faq: [
            { question: 'Wat is de minimale commitment?', answer: 'Geen minimum! Je start automatisch als Silver Partner bij je eerste event en groeit organisch naar Gold/Platinum op basis van volume.' },
            { question: 'Hoe werkt de referral fee?', answer: 'Gold Partners krijgen 5%, Platinum 10% van de omzet van door hen aangebrachte nieuwe klanten. Uitbetaling na afloop van het event.' },
            { question: 'Kunnen jullie mijn branding gebruiken?', answer: 'Ja. Platinum Partners hebben toegang tot white-label service waarbij wij onder jouw branding opereren. Servetten, menu\'s - alles in jouw stijl.' },
            { question: 'Hoe snel krijg ik een offerte?', answer: 'Silver Partners: 48 uur. Gold Partners: 2 uur. Platinum Partners: Instant via dedicated lijn. Volledige offertes met alle details.' },
            { question: 'Wat als ik moet annuleren?', answer: 'Partners hebben flexibele annulering tot 48 uur vooraf zonder kosten. Bij noodgevallen zoeken we altijd naar een oplossing.' },
            { question: 'Hoe werkt de co-marketing?', answer: 'Wij maken hi-res foto\'s en video\'s van je events. Case studies met quotes. Instagram content. Gold/Platinum Partners krijgen ook een marketing budget voor gezamenlijke campagnes.' }
        ]
    },
    verenigingen: {
        id: 'verenigingen',
        title: 'De Partner voor',
        subtitle: 'Uw Vereniging',
        heroImage: '/images/vereniging.png',
        description: 'Sportclubs, cultuurverenigingen, jeugdbewegingen - wij begrijpen de realiteit van vrijwilligersorganisaties. Flexibel, betaalbaar, en altijd met een glimlach. Word jaarpartner en profiteer van verenigingsvoordelen.',
        heroButtons: [
            { text: 'Vraag Offerte', link: '/contact', variant: 'primary' },
            { text: 'Jaarpartner Worden', link: '#packages', variant: 'secondary' },
            { text: 'Sponsoring Info', link: '#sponsoring', variant: 'accent' }
        ],
        accentColor: '#ea580c',
        storyTitle: 'Samen Sterker',
        storySubtitle: 'Als Community',
        storyContent: 'Wij weten hoe het is: beperkt budget, vrijwilligers die last-minute afzeggen, en een bestuur dat overtuigd moet worden. FrietPlus past zich aan jouw realiteit aan. Flexibele aantallen, gespreide betaling, en sponsoring opties die jouw kas spekken.',
        whyTitle: 'Waarom Verenigingen Kiezen voor FrietPlus',
        whyFeatures: [
            { icon: 'fas fa-piggy-bank', title: 'Budget Zekerheid', description: 'Vaste all-in prijzen zonder verrassingen. Geen verborgen kosten voor transport, setup of afval. Jij weet vooraf exact wat het kost.' },
            { icon: 'fas fa-handshake-simple', title: 'Vrijwilliger-Vriendelijk', description: 'Aantallen mogen tot 48u vooraf wijzigen (-20% tot +10%). Wij snappen dat vrijwilligers soms last-minute afzeggen.' },
            { icon: 'fas fa-coins', title: 'Gespreide Betaling', description: 'Betaal 50% vooraf, 50% achteraf. Of vraag naar onze termijnregeling bij grote events. Jouw cashflow, onze flexibiliteit.' },
            { icon: 'fas fa-bullhorn', title: 'Sponsoring Opties', description: 'Logo op onze truck tijdens jouw event. Branded servetten. Omzetdeling bij open verkoop. Extra inkomsten voor de kas!' },
            { icon: 'fas fa-users', title: 'Community Korting', description: '15% verenigingskorting standaard. Jaarpartners krijgen tot 20% en priority booking voor populaire data.' },
            { icon: 'fas fa-heart', title: 'Lokale Binding', description: 'Wij sponsoren graag lokale initiatieven. Vraag naar onze mogelijkheden voor jeugdteams en sociale projecten.' }
        ],
        packagesTitle: 'Verenigingspakketten',
        packagesSubtitle: 'Van eenmalig tot jaarpartnership',
        packages: [
            {
                name: 'Clubfeest',
                subtitle: 'Eenmalig event (50-100 pers.)',
                price: '€11',
                priceNote: 'per persoon',
                emoji: '🎊',
                features: ['15% verenigingskorting', 'Flexibele aantallen (-20%)', '2 uur service', 'Friet + 2 snacks pp', 'Basis sauzen pakket', 'Complete setup & cleanup'],
                buttonText: 'Boek Clubfeest'
            },
            {
                name: 'Jaarpartner',
                subtitle: '3+ events per jaar',
                price: '€9',
                priceNote: 'per persoon',
                emoji: '🤝',
                popular: true,
                features: ['20% jaarkorting', 'Priority booking populaire data', 'Logo op truck optie', 'Gespreide betaling mogelijk', 'Vaste contactpersoon', 'Sponsored servetten'],
                buttonText: 'Word Jaarpartner'
            },
            {
                name: 'Sponsordeal',
                subtitle: 'Open verkoop events',
                price: 'Geen Vooraf',
                priceNote: 'omzetdeling',
                emoji: '💰',
                features: ['Geen investering', 'Wij regelen alles', 'Omzetdeling (30% vereniging)', 'Perfect voor festivals', 'Eigen branding mogelijk', 'Fondsenwerving zonder risico'],
                buttonText: 'Bespreek Sponsordeal'
            }
        ],
        stories: [
            {
                name: 'Tom V.',
                location: 'Voorzitter FC Sportief',
                date: 'Jaarpartner sinds 2023',
                content: '"Al 3 jaar onze vaste partner voor alle clubevents. De flexibiliteit met aantallen is goud waard - vrijwilligers blijven nou eenmaal onvoorspelbaar. En die 20% korting heeft ons al duizenden euro\'s bespaard."',
                tags: ['Jaarpartner', 'Sportclub', '3 jaar']
            },
            {
                name: 'An D.',
                location: 'Penningmeester Harmonie Sint-Cecilia',
                date: 'Sponsordeal 2024',
                content: '"De sponsordeal was perfect voor ons jaarlijks festival. Geen investering vooraf en toch 30% van de omzet voor de kas. €1.200 verdiend die direct naar nieuwe instrumenten ging!"',
                tags: ['Sponsordeal', 'Cultuurvereniging', 'Fondsenwerving']
            },
            {
                name: 'Pieter M.',
                location: 'Leider Scouts Gent',
                date: 'Meerdere events 2024',
                content: '"De gespreide betaling was voor ons als jeugdbeweging echt een uitkomst. En het personeel weet perfect hoe ze met een groep enthousiaste scouts moeten omgaan!"',
                tags: ['Jeugdbeweging', 'Gespreide betaling', 'Scouts']
            }
        ],
        tastingInfo: {
            title: 'Sponsoring & Partnerships',
            subtitle: 'Samen sterker - vraag naar de mogelijkheden',
            features: ['Logo op truck tijdens event', 'Branded servetten & verpakking', 'Omzetdeling bij open verkoop', 'Sponsoring jeugdteams', 'Lokale initiatieven support', 'Social media shoutouts'],
            buttonText: 'Bespreek Sponsoring'
        },
        faq: [
            { question: 'Wat is het minimum aantal personen?', answer: 'Voor verenigingen hanteren we een minimum van 50 personen. Bij jaarpartnership kunnen we voor kleinere events flexibel zijn.' },
            { question: 'Hoe werkt de gespreide betaling?', answer: '50% bij boeking, 50% na afloop. Bij grote events (500+ pers.) kunnen we een termijnregeling bespreken. Vraag naar de mogelijkheden.' },
            { question: 'Wat als er minder mensen komen?', answer: 'Tot 48 uur vooraf mag je aantallen aanpassen: -20% tot +10% zonder extra kosten. Wij snappen de vrijwilligersrealiteit.' },
            { question: 'Hoe werkt de sponsordeal?', answer: 'Wij komen met de truck, jullie leveren de locatie en promotie. Bij open verkoop krijgt de vereniging 30% van de omzet. Geen risico, alleen maar opbrengst.' },
            { question: 'Kunnen we jullie logo gebruiken voor promotie?', answer: 'Ja! Jaarpartners krijgen access tot ons promotiemateriaal. We delen graag jullie events op onze social media.' },
            { question: 'Bieden jullie kortingen voor jeugdteams?', answer: 'Ja. Voor erkende jeugdbewegingen en jeugdteams hebben we speciale tarieven. Neem contact op voor meer info.' },
            { question: 'Wat houdt het jaarpartnerschap in?', answer: 'Bij 3+ events per jaar word je jaarpartner: 20% korting, priority booking, en een vaste contactpersoon. Het vernieuwt automatisch elk jaar.' },
            { question: 'Kunnen jullie ook een tombola sponsoren?', answer: 'Zeker! We doneren graag vouchers voor jullie tombola of verloting. Vraag naar de mogelijkheden.' }
        ]
    }
};
